import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { adminApi, imgUrl, errMsg } from "../../lib/api";

export const ImageUpload = ({ value, onChange, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await adminApi.post("/admin/upload", fd);
      onChange(r.data.path);
    } catch (er) {
      toast.error(errMsg(er, "Resim yüklenemedi"));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative w-full h-44 rounded-2xl overflow-hidden" data-testid={`${testid}-preview`}>
          <img src={imgUrl(value)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center" data-testid={`${testid}-remove`}>
            <X size={16} />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testid}-upload-btn`}
          className="w-full h-32 rounded-2xl border-2 border-dashed border-black/15 flex flex-col items-center justify-center gap-2 text-slate-500 hover:border-[#1B4332] hover:text-[#1B4332] transition-colors">
          <ImagePlus size={26} />
          <span className="text-sm font-semibold">{busy ? "Yükleniyor..." : "Telefondan / bilgisayardan resim seç"}</span>
        </button>
      )}
    </div>
  );
};
